import { Component } from '@angular/core';

@Component({
  selector: 'app-trends-reports',
  templateUrl: './trends-reports.component.html',
  styleUrls: ['./trends-reports.component.scss']
})
export class TrendsReportsComponent {

}
